import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, of} from "rxjs";
import {IUserInfo} from "../models/userInfo.interface";
import {BaseApiService} from "../../common/base-api.service";
import {HttpClient} from "@angular/common/http";
import {SettingsProviderService} from "../../common/settings-provider.service";
import {CompanyInfo} from '../../domain-model/company-info.class';

@Injectable({
  providedIn: 'root'
})
export class OurUserService extends BaseApiService {
  private _loggedInUser: IUserInfo
  private _loadingUser: boolean = false;
  private observedUser: Observable<IUserInfo>;
  private selectedUserSubject = new BehaviorSubject<IUserInfo>(null);
  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'User');
  }
  public getLoggedInUser(): Observable<IUserInfo> {
    if (this._loadingUser) {
      return this.observedUser;
    }
    else if (this._loggedInUser) {
      this.notifyLoggedInUserChange();
      return of(this._loggedInUser);
    }
    else {
      this._loadingUser = true;
      this.observedUser = this.post<IUserInfo>('GetLoggedInUser');
      this.observedUser.subscribe(
        {
          next: result => {
            this._loggedInUser = result;
            this._loadingUser = false;
            this.notifyLoggedInUserChange();

          }
        });
      return this.observedUser;
    }
  }
  getLoggedInUserSubject(): Observable<IUserInfo> {
    return this.selectedUserSubject.asObservable();
  }
  private notifyLoggedInUserChange(){
    this.selectedUserSubject.next(this._loggedInUser);
  }
  updateUserCompanyDetails(companyId: string, companyName: string){
    this._loggedInUser.companyId = companyId;
    this._loggedInUser.companyName = companyName;
    this.notifyLoggedInUserChange();
  }
}
